<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <paginated-table :id="$attrs['id']"
                   :hover="false"
                   :rows="transactions"
                   :draggable="showDragHandle"
                   :items-per-page="20"
                   :columns="`${6 + (showDragHandle ? 1 : 0) + (created ? 1 : 0) + (cancelled ? 1 : 0) + (restored ? 1 : 0)}`"
                   grid-template-columns="repeat(calc(var(--table-columns) - 1), auto) max-content"
                   min-width="800px">
    <template slot="table-head">
      <div v-if="showDragHandle" class="hm-table__th"></div>
      <div class="hm-table__th">{{ $t('table.transactionTable.chargePeriod') }}</div>
      <div class="hm-table__th">{{ $t('table.transactionTable.label') }}</div>
      <div v-if="created" class="hm-table__th">{{ $t('table.transactionTable.lastModified') }}</div>
      <div v-if="cancelled" class="hm-table__th">{{ $t('table.transactionTable.cancelled') }}</div>
      <div v-if="restored" class="hm-table__th">{{ $t('table.transactionTable.restored') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transactionTable.count') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transactionTable.singleItemAmount') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transactionTable.totalAmount') }}</div>
      <div class="hm-table__th text-right">{{ $t('table.transactionTable.actions') }}</div>
    </template>
    <template v-slot:default="slotProps">
      <template v-for="trans in slotProps.currentPage">
        <div v-if="showDragHandle" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">
          <span v-tooltip="{ title: $t('table.transactionTable.dragForTransfer'), delay: 250, placement: 'right', positionFixed: true, trigger: 'hover', touch: false }"
                draggable="true"
                class="grippy"
                @dragstart="dragstart($event, trans)"
                @dragover.prevent
                @dragenter="dragenter($event, trans)"
                @dragleave="dragleave($event, trans)"
                @dragend="dragend($event, trans)"
                @drop="drop($event, trans)"></span>
        </div>
        <div v-if="!isEmpty(trans.chargePeriod) && !isNil(trans.chargePeriod.startDate) && !isNil(trans.chargePeriod.endDate)" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">{{ trans.chargePeriod.startDate | toDate }} - {{ trans.chargePeriod.endDate | toDate }}</div>
        <div v-else :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">{{ trans.businessDate | toDate }}</div>
        <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" :title="trans.comment" class="hm-table__td">{{ trans.label }}{{ additionalLabel(trans) }}</div>
        <div v-if="created" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">
          <template v-if="!isEmpty(trans.lastModified)">
            {{ trans.lastModified | toLocalDateTime }} // {{ trans.lastModifiedBy }}
          </template>
          <template v-else>
            {{ trans.creationDate | toLocalDateTime }} // {{ trans.userName }}
          </template>
        </div>
        <div v-if="cancelled" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td">{{ trans.cancelledAt | toLocalDateTime }} // {{ trans.cancelledBy }}</div>
        <div v-if="restored" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td"><template v-if="!isEmpty(trans.restoredAt)">{{ trans.restoredAt | toLocalDateTime }} // {{ trans.restoredBy }}</template></div>
        <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td text-right">{{ trans.itemCount }}</div>
        <div v-if="trans.code.type === 'TransactionGroup' || trans.code.type === 'RatePlan'" :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td text-right"></div>
        <div v-else :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td text-right">{{ trans.itemCount === 0 ? 0 : trans.amount / trans.itemCount | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td text-right">{{ trans.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
        <div :class="[{'hm-table__td--has-child-rows': hasChildTrans(trans)}]" class="hm-table__td text-right">
          <div class="hm-table__td hm-table__td--icon">
            <v-nodes :scoped-vnodes="$scopedSlots.b1" :data="{ transaction: trans }" />
            <v-nodes :scoped-vnodes="$scopedSlots.b2" :data="{ transaction: trans }" />
            <v-nodes :scoped-vnodes="$scopedSlots.b3" :data="{ transaction: trans }" />
          </div>
        </div>
        <template v-for="childTrans in trans.childTransactions">
          <template v-if="childTransactionFilter(trans, childTrans)">
            <div v-if="showDragHandle" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td"></div>
            <div v-if="!isEmpty(childTrans.chargePeriod) && !isNil(childTrans.chargePeriod.startDate) && !isNil(childTrans.chargePeriod.endDate)" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td">{{ childTrans.chargePeriod.startDate | toDate }} - {{ childTrans.chargePeriod.endDate | toDate }}</div>
            <div v-else :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td">{{ childTrans.businessDate | toDate }}</div>
            <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td">{{ childTrans.label }}</div>
            <div v-if="created" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td"></div>
            <div v-if="cancelled" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td"></div>
            <div v-if="restored" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td"></div>
            <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td text-right">{{ childTrans.itemCount }}</div>
            <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td text-right">{{ childTrans.itemCount === 0 ? 0 : childTrans.amount / childTrans.itemCount | toCurrency }} {{ hotelSettings.details.currency }}</div>
            <div v-if="trans.code.type === 'TransactionGroup' || (trans.code.type === 'RatePlan'&& childTrans.includedInParent)" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td text-right"></div>
            <div v-else :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td text-right">{{ childTrans.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
            <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(trans, childTrans)}]" class="hm-table__td text-right">
              <div class="hm-table__td hm-table__td--icon">
                <v-nodes :scoped-vnodes="$scopedSlots.cb1" :data="{ transaction: trans, childTransaction: childTrans }" />
                <v-nodes :scoped-vnodes="$scopedSlots.cb2" :data="{ transaction: trans, childTransaction: childTrans }" />
                <v-nodes :scoped-vnodes="$scopedSlots.cb3" :data="{ transaction: trans, childTransaction: childTrans }" />
              </div>
            </div>
            <template v-for="childTrans2 in childTrans.childTransactions">
              <template v-if="childTransactionFilter(childTrans, childTrans2)">
                <div v-if="showDragHandle" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td"></div>
                <div v-if="!isEmpty(childTrans2.chargePeriod) && !isNil(childTrans2.chargePeriod.startDate) && !isNil(childTrans2.chargePeriod.endDate)" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td">{{ childTrans2.chargePeriod.startDate | toDate }} - {{ childTrans2.chargePeriod.endDate | toDate }}</div>
                <div v-else :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td">{{ childTrans2.businessDate | toDate }}</div>
                <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td">{{ childTrans2.label }}</div>
                <div v-if="created" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td"></div>
                <div v-if="cancelled" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td"></div>
                <div v-if="restored" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td"></div>
                <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td text-right">{{ childTrans2.itemCount }}</div>
                <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td text-right">{{ childTrans2.itemCount === 0 ? 0 : childTrans2.amount / childTrans2.itemCount | toCurrency }} {{ hotelSettings.details.currency }}</div>
                <div v-if="childTrans.code.type === 'TransactionGroup' || (childTrans.code.type === 'RatePlan'&& childTrans2.includedInParent)" :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td text-right"></div>
                <div v-else :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td text-right">{{ childTrans2.amount | toCurrency }} {{ hotelSettings.details.currency }}</div>
                <div :class="[{'hm-table__td--has-child-rows': !isLastChildTrans(childTrans, childTrans2)}]" class="hm-table__td text-right">
                  <div class="hm-table__td hm-table__td--icon">
                    <v-nodes :scoped-vnodes="$scopedSlots.cb1" :data="{ transaction: childTrans, childTransaction: childTrans2 }" />
                    <v-nodes :scoped-vnodes="$scopedSlots.cb2" :data="{ transaction: childTrans, childTransaction: childTrans2 }" />
                    <v-nodes :scoped-vnodes="$scopedSlots.cb3" :data="{ transaction: childTrans, childTransaction: childTrans2 }" />
                  </div>
                </div>
              </template>
            </template>
          </template>
        </template>
      </template>
      <template v-if="showDragHandle">
        <div v-for="trans in transactions" :id="`dragImage-${trans.id}`" style="width: auto;max-width:100vw;position:fixed;left:200vw;font-size: 1.4rem;">
          <table style="width:100%;">
            <tr>
              <td v-if="!isEmpty(trans.chargePeriod) && !isNil(trans.chargePeriod.startDate) && !isNil(trans.chargePeriod.endDate)" style="padding: 5px 10px 5px 5px;">{{ trans.chargePeriod.startDate | toDate }} - {{ trans.chargePeriod.endDate | toDate }}</td>
              <td v-else style="padding: 5px 10px 5px 5px;">{{ trans.businessDate | toDate }}</td>
              <td style="padding: 5px 10px;">{{ trans.label }}{{ additionalLabel(trans) }}</td>
              <td style="padding: 5px 5px 5px 10px;" class="text-right">{{ trans.amount | toCurrency }} {{ hotelSettings.details.currency }}</td>
            </tr>
          </table>
        </div>
      </template>
    </template>
  </paginated-table>
</template>

<script>

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, groupBy, values, head, cloneDeep, concat, unionBy, reverse, sortBy, last } from 'lodash';

export default {
  name: 'TransactionTable',

  mixins: [HotelmeisterMixin],

  props: {
    transactions: {
      type: Array,
      required: true,
      default: () => [],
    },
    created: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancelled: {
      type: Boolean,
      required: false,
      default: false,
    },
    restored: {
      type: Boolean,
      required: false,
      default: false,
    },
    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
    parentId: {
      type: String,
      required: false,
      default: null,
    },
    folioId: {
      type: String,
      required: false,
      default: null,
    },
  },

  data: function () {
    return {
      dragTransaction: null,
    };
  },

  computed: {
    showDragHandle: function () {
      return this.draggable && (this.$store.getters['layout/activeBreakpoint'] === 'desktop' || this.$store.getters['layout/activeBreakpoint'] === 'hd');
    },
  },

  methods: {
    dragstart($event, trans) {
      $event.dataTransfer.effectAllowed = 'move';
      $event.dataTransfer.dropEffect = 'none';
      $event.dataTransfer.setData('text/plain', JSON.stringify(
        {
          transactionId: trans.id,
          folioId: this.folioId,
          parentId: this.parentId,
        },
      ));

      this.dragTransaction = trans;

      const crt = document.querySelector(`#dragImage-${trans.id}`);
      crt.style.backgroundColor = '#eceeed';

      $event.dataTransfer.setDragImage(crt, 0, 0);

      this.$serviceBus.$emit('transaction.dragstart');
    },
    dragenter($event, trans) {
    },
    dragend($event, trans) {
      this.dragTransaction = null;
      this.$serviceBus.$emit('transaction.dragend');
    },
    dragleave($event, trans) {
    },
    drop($event, trans) {
    },
    additionalLabel(trans) {
      if (trans.code.type === 'RatePlan') {
        let ret = '';
        if (!isEmpty(trans.calculationDetails.roomNumber)) {
          ret += ` Zi. ${trans.calculationDetails.roomNumber}`;
        }
        if (!isEmpty(trans.calculationDetails.roomTypeId)) {
          ret += ` (${this.findHotelSettingById('roomTypes', trans.calculationDetails.roomTypeId).abbreviation})`;
        }
        if (!isEmpty(trans.reservationId)) {
          ret += `, Res #${this.id2number(trans.reservationId)}`;
        }
        ret = ret.trim();
        if (!isEmpty(ret)) {
          ret = ` // ${ret}`;
        }
        return ret;
      } else {
        return null;
      }
    },
    id2number: function (value) {
      if (isEmpty(value)) return '';
      return last(value.split('::'));
    },
    childTransactionFilter(trans, childTrans) {
      return (childTrans.includedInParent === false || trans.code.type === 'TransactionGroup' || trans.code.type === 'RatePlan') && !(childTrans.includedInParent === true && childTrans.code.type === 'Tax' && this.findHotelSettingById('taxes', childTrans.code.id).taxType !== 'CityTax');
    },
    hasChildTrans(trans) {
      return isNil(trans.childTransactions) ? false : trans.childTransactions.filter(it => this.childTransactionFilter(trans, it)).length > 0;
    },
    isLastChildTrans(trans, childTrans) {
      const lastTransaction = last(trans.childTransactions.filter(it => this.childTransactionFilter(trans, it)));
      if (lastTransaction === childTrans) {
        return !this.hasChildTrans(lastTransaction);
      } else {
        return false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '~styles/import';

</style>

<style lang="scss">
  span.grippy {
    content: '....';
    width: 20px;
    height: 25px;
    white-space: normal;
    font-weight: normal;
    display: inline-block;
    overflow: hidden;
    line-height: 5px;
    padding: 3px 4px;
    cursor: move;
    vertical-align: middle;
    margin-top: -.7em;
    margin-right: .3em;
    font-size: 12px;
    font-family: sans-serif;
    letter-spacing: 2px;
    color: #cccccc;
    text-shadow: 1px 0 1px black;
    pointer-events: all;
  }
  span.grippy::after {
    content: '.. .. .. ..';
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/table/TransactionTable.vue